/**
 * account.saiteki.works へのリダイレクトURLを返す。
 * - コールバックパスを指定した場合は、ログイン後にコールバックパスにリダイレクトする。
 * - コールバックパスを指定しない場合は、ログイン後にテーブル一覧画面にリダイレクトする。
 * @param callbackPath リダイレクト後に戻すコールバックパス。
 */
export function redirectToLogin(callbackPath?: string): string {
	const accountUrl = import.meta.env.VITE_APP_ACCOUNT_URL
	const path = callbackPath ?? "/tables"
	const redirectTo = encodeURIComponent(`${window.location.origin}${path}`)
	return `${accountUrl}login?redirectTo=${redirectTo}`
}
